import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    applySortPlayer,
} from '../../../actions/FilterActions';
import common from '../../../common';
import config from './../../../config';
import OutsideNotifier from '../../../OutsideNotifier';
import { Scrollbars } from 'react-custom-scrollbars';

class PlayerSortByWeb extends Component {

    constructor(props) {
        super(props);
        this.state = {

            showDropDown: false
        }

    }

    toggleDrpDown = (val) => {
        if (val == false) {
            this.setState({
                dropdwnActive: false
            })
        } else {
            this.setState({
                dropdwnActive: !this.state.dropdwnActive
            })
            if (!this.state.dropdwnActive) {
                common.customTracking('Select Show Filter', common.getPageName());
            }
        }

    }

    getActiveStatus = () => {
        let count = 0
        for (var i = 0; i < this.props.playerStatus.length; i++) {
            if (this.props.playerStatus[i].active) {
                count = count + 1;
            }
        }

        return count
    }

    resetPlayerStatus = (e) => {
        e.stopPropagation();
        let self = this;
        this.props.playerStatus.map((el) => {
            if (el.active) {
                self.props.applySortPlayer(el);
            }
        })

    }


    onSortApply = (e, sortOption) => {
        e.stopPropagation();
        this.props.applySortPlayer(sortOption);
        this.props.playerStatus.map(function (obj) {
            if (sortOption.id == obj.id && obj.active) {

            } else {
                common.customTracking('Select Show filter - ' + sortOption.label, common.getPageName());
            }
        })


    };

    render() {
        let trans = this.props.trans;
        const className = common.makeClasses({
            'si-selectBoxes': true,
            'si-status-box': true,
            'si-active': this.state.showDropDown,
        });

        return <div className={ className }>

            <div className="si-dropdown-btn si-flexBox" onClick={ () => { this.toggleDrpDown() } }>

                { this.getActiveStatus() <= 0 ? <div className="si-tp-wrap si-flexBox" >
                    <span className="si-tp">{ this.props.trans.dropDwonPlystatus ? this.props.trans.dropDwonPlystatus : "status" }</span>
                    { this.getActiveStatus() > 0 ? <span className="si-close" onClick={ (e) => this.resetPlayerStatus(e) }>
                        <i className="icon-ucl-close"></i>
                    </span> : null }
                    <i className="icon-ucl-position"></i>
                </div> : <div className="si-selected-clubs si-flexBox">
                        <div className="si-selected-wrap si-flexBox">
                            { this.props.playerStatus.map((el) => {
                                if (el.active) {
                                    return <i key={ el.id } onClick={ (e) => { this.onSortApply(e, el) } } className={ el.siIcon }></i>
                                } else {
                                    return null
                                }

                            }) }
                            { this.getActiveStatus() > 2 ? <span className="si-selected-clubs-count">+{ this.getActiveStatus() }</span> : "" }
                        </div>
                        <span className="si-close" onClick={ (e) => this.resetPlayerStatus(e) }>
                            <i className="icon-ucl-close"></i>
                        </span>
                        <i className="icon-ucl-position"></i>
                    </div> }
                { this.state.dropdwnActive ?

                    <OutsideNotifier
                        handler={ () => this.toggleDrpDown(false) }>
                        <ul className="si-dropdown-options" style={ common.setDropDownHeight("#playerRecomendationDropDownMobFilter", 38, this.props.playerStatus.length) }>
                            { this.props.playerStatus.map((el) => {
                                const className = common.makeClasses({
                                    'si-active': el.active
                                })
                                return <li className={ className } key={ el.id } onClick={ (e) => { this.onSortApply(e, el) } }>
                                    <div className="si-custom-chkbox">
                                        <input type="checkbox" { ...{ checked: el.active } } />
                                        <div className="si-check-mark"></div>
                                    </div>
                                    <div className="si-club-img si-flexBox">
                                        <i className={ el.siIcon }></i>
                                        <span>{ trans[el.label] ? trans[el.label] : el.lable }</span>
                                    </div>
                                </li>
                            }) }

                        </ul>
                    </OutsideNotifier> : "" }
            </div >
        </div >


    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        playerStatus: state.formationData.playerFilters.playerStatus,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applySortPlayer: (ele) => dispatch(applySortPlayer(ele)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerSortByWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PlayerSortByWeb.js